module.exports = __webpack_public_path__ + "img/homeworkManagement.3935f920.jpg";